























































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { UserDto } from '@/models/dtos/userDto'
import { UserAdminService as _userAdminService } from '@/admin/services/userAdmin.service'
import { EmployeeTypeDto } from '@/models/dtos/employeeTypeDto'
import router from '@/router'
import { SelectDto } from '@/models/dtos/selectDto'
import { SelectMixin } from '@/mixins/SelectMixin'
import { mixins } from 'vue-class-component'
import { ValidationObserver } from 'vee-validate'
import { RoleDto } from '@/models/dtos/roleDto'
import { EUserStatus } from '@/models/dtos/enums/eUserStatus'
import { UserMixin } from '@/mixins/userMixin'

@Component
export default class AdminAccountCreateOrUpdate extends mixins(SelectMixin, UserMixin) {
  // Ref
  $refs!: {
    accountForm: InstanceType<typeof ValidationObserver>;
    accountPasswordForm: InstanceType<typeof ValidationObserver>;
  }

  // Data
  private userId: string | null = null
  private user: UserDto | null = null
  private roles: RoleDto[] | null = null
  private employeeTypes: EmployeeTypeDto[] | null = null
  private employeeTypesSelect: SelectDto[] = []
  private userStatuses: SelectDto[] = []

  // Methods
  private async initUser() {
    this.userId = (this.$route.params as any)?.id || null

    this.user = {
      firstName: '',
      lastName: '',
      userName: '',
      password: '111111',
      phoneNumber: '',
      email: '',
      employeeType: this.employeeTypes![0],
      status: EUserStatus.Active,
      roles: [] as string[]
    } as UserDto

    if (this.userId) {
      this.user = await _userAdminService.get(this.userId) || this.user
    }
  }

  private initEmployeeTypesSelect() {
    this.employeeTypesSelect = this.mapObjectToSelect(this.employeeTypes!, { value: 'id', text: 'name' })
  }

  private initUserStatusesSelect() {
    this.userStatuses = this.mapEnumToSelect(EUserStatus, this.userStatusName, [])
  }

  private setNewEmployeeType(id: string) {
    const type = this.employeeTypes!.find(e => e.id === id)
    this.user!.employeeType = type || this.user!.employeeType
  }

  private async saveOrUpdate(evt: any) {
    evt.preventDefault()

    if (!this.userId) {
      const userId = await _userAdminService.add(this.user!)
      router.push({ name: 'AdminAccountEdit', params: { id: userId.toString() } })
    } else {
      _userAdminService.edit(this.user!)
    }
  }

  private async setUserName(userName: string) {
    if (!this.userId && this.user?.firstName.length && this.user?.lastName.length) {
      const userName = `${this.user.firstName}_${this.user.lastName}`
      this.user!.userName = await _userAdminService.GetUserName(userName)
    }
  }

  private async resetPassword(evt: any) {
    evt.preventDefault()

    await _userAdminService.resetPassword(this.userId!, this.user!.password)
    this.user!.password = ''
    this.$refs.accountPasswordForm.reset()
  }

  // Getters
  private get isLoaded(): boolean {
    return !this.employeeTypes || !this.user || !this.roles
  }

  // Lifecycle
  async created() {
    this.employeeTypes = await _userAdminService.GetEmployeeTypes()
    this.roles = await _userAdminService.GetRoles()

    this.initEmployeeTypesSelect()
    this.initUserStatusesSelect()
    this.initUser()
  }

  // Watchers
  @Watch('$route')
  async onRouteChange() {
    this.initUser()
    this.$refs.accountForm.reset()
  }
}
